'use client';
import certificationImageData from '@/constants/certificationImageData';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import 'yet-another-react-lightbox/styles.css';

// Swiper
import Container from '@/components/ui/Container';
import SectionTitle from '@/components/ui/SectionTitle';
import '@/styles/customSwipper.css';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const CertificationGallery = () => {
  const [index, setIndex] = useState(-1);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null; // Prevent hydration mismatch

  return (
    <Container>
      <SectionTitle title="Certifications" />

      {/* Swiper Slider */}
      <Swiper
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
        modules={[EffectCoverflow, Autoplay]}
        className="mySwiper"
        breakpoints={{
          320: {
            slidesPerView: 2,
          },
          800: {
            slidesPerView: 4,
          },
        }}
      >
        {certificationImageData?.map((photo, idx) => (
          <SwiperSlide
            key={idx}
            onClick={() => setIndex(idx)}
            className="group relative h-[420px] w-[300px] cursor-pointer overflow-hidden"
          >
            <Image
              height={photo.height}
              width={photo.width}
              src={photo.src}
              alt={photo.title}
              className="h-full w-full scale-100 object-cover transition-transform duration-700 group-hover:scale-110"
            />

            <div className="absolute top-0 left-0 z-10 flex h-full w-full flex-col items-center justify-center bg-black/40 text-center opacity-0 transition-opacity duration-500 group-hover:opacity-100">
              <h1 className="text-xl font-bold text-white">{photo.title}</h1>
              <p className="mt-2 text-white opacity-0 transition-opacity duration-700 group-hover:opacity-100">
                {photo.description}
              </p>
            </div>

            <div className="absolute inset-0 z-0 bg-gradient-to-b from-transparent to-black opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Lightbox */}
      <Lightbox
        index={index}
        slides={certificationImageData.map((slide) => ({
          src: slide.src,
          alt: slide.title,
        }))}
        open={index >= 0}
        close={() => setIndex(-1)}
        plugins={[Fullscreen]}
      />
    </Container>
  );
};

export default CertificationGallery;
